import 'css-chunksrc/client/pages/documentsPage/sideBar/directoryStructure/styles.scss';export default {
  "header": "_header_11t0b_1",
  "name": "_name_11t0b_10",
  "toggleIconBox": "_toggleIconBox_11t0b_14",
  "toggleIcon": "_toggleIcon_11t0b_14",
  "icon": "_icon_11t0b_24",
  "children": "_children_11t0b_36",
  "root": "_root_11t0b_40",
  "open": "_open_11t0b_45",
  "selected": "_selected_11t0b_49",
  "dropZone": "_dropZone_11t0b_69"
};